import { useMutation, useQueryClient } from "@tanstack/react-query";

// Any playbook change can move the list counts, the version and the changelog, so refresh all of Lens.
const useLensMutation = <TVariables, TData>(mutationFn: (variables: TVariables) => Promise<TData>) => {
    const queryClient = useQueryClient();
    return useMutation<TData, Error, TVariables>({
        mutationFn,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ["lens"] }),
    });
};

export default useLensMutation;
